import { S3Client, PutObjectCommand, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

const s3Client = new S3Client({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: {
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    },
});

export const uploadToS3 = async (file, fileName) => {
    const command = new PutObjectCommand({
        Bucket: process.env.REACT_APP_S3_BUCKET,
        Key: `audio/${fileName}`,
        Body: file,
        ContentType: file.type,
    });

    try {
        await s3Client.send(command);
        return `https://${process.env.REACT_APP_S3_BUCKET}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/audio/${fileName}`;
    } catch (error) {
        console.error('Error uploading to S3:', error);
        throw error;
    }
};

export const getSignedDownloadUrl = async (key) => {
    const command = new GetObjectCommand({
        Bucket: process.env.REACT_APP_S3_BUCKET,
        Key: key,
    });

    return await getSignedUrl(s3Client, command, { expiresIn: 3600 });
};